import React from 'react';
import { TrashIcon } from '../../Icons';
import { Button } from '../../StyledComponents';
import { StatusLabel } from '../../ui/StatusLabel';
import { DroneInfo } from './DroneCard';

interface DroneDetailsPanelProps {
	drone: DroneInfo;
	status?: 'ONLINE' | 'OFFLINE';
	onDelete: (drone: DroneInfo) => void;
	onEdit: (drone: DroneInfo) => void;
}

export const DroneDetailsPanel: React.FC<DroneDetailsPanelProps> = ({
	drone,
	status,
	onDelete,
	onEdit,
}) => {
	return (
		<div className="w-full max-w-[620px]">
			<div className="rounded-[20px] border-2 border-[#0063A3] bg-white p-8">
				<div className="mb-8 flex items-start justify-between gap-6">
					<div>
						<h2 className="mb-6 text-2xl font-semibold text-[#333333]">
							{drone.name}
						</h2>

						<div className="grid grid-cols-[80px_1fr] gap-x-4 text-base text-[#333333]">
							<span className="text-[#666666]">Call Sign</span>
							<span className="font-semibold">{drone.callsign ?? '-'}</span>
							<span className="text-[#666666]">Modell</span>
							<span className="font-semibold">{drone.droneType.name}</span>
							<span className="text-[#666666]">Seriennr.</span>
							<span className="font-semibold">{drone.serialNumber ?? '-'}</span>
						</div>
					</div>

					{status && <StatusLabel>{status}</StatusLabel>}
				</div>

				<div className="mb-8 h-px bg-[#333333]" />

				<div className="flex flex-col gap-7 text-base text-[#333333]">
					<div>
						<p className="mb-4 font-semibold text-[#333333]">Name</p>
						<p className="text-[#333333]">{drone.name}</p>
					</div>

					<div className="grid grid-cols-2 gap-x-12 gap-y-7">
						<div>
							<p className="mb-4 font-semibold text-[#333333]">
								Reichweite (m)
							</p>
							<p className="text-[#333333]">
								{drone.droneType.reachDiameter}
							</p>
						</div>
						<div>
							<p className="mb-4 font-semibold text-[#333333]">
								Geschwindigkeit (m/s)
							</p>
							<p className="text-[#333333]">{drone.droneType.flightSpeed}</p>
						</div>
						<div>
							<p className="mb-4 font-semibold text-[#333333]">
								Max. Flugzeit (min)
							</p>
							<p className="text-[#333333]">
								{drone.droneType.maxFlightTime}
							</p>
						</div>
						<div>
							<p className="mb-4 font-semibold text-[#333333]">
								Start/Stop Zeit (s)
							</p>
							<p className="text-[#333333]">{drone.droneType.startStopTime}</p>
						</div>
					</div>
				</div>
			</div>

			<div className="mt-8 flex justify-end gap-5">
				<Button
					className="border border-[#E1320F] text-[#E1320F] gap-2"
					onClick={() => onDelete(drone)}
				>
					<TrashIcon />
					Löschen
				</Button>
				<Button
					className="h-12 rounded-full bg-[#E1320F] px-10 text-sm font-semibold text-white"
					onClick={() => onEdit(drone)}
					primary
				>
					Bearbeiten
				</Button>
			</div>
		</div>
	);
};
